<template>
  <section :id="`comp_id_${compProps.elementId}`">
    <component :is="compName" :compProps="docContent" :compId="(compProps.elementId+'')"></component>
  </section>
</template>
<script>
import DocContent from '@/components/DocContent'

export default {
  name: 'ElementDocComp',
  components: {
    DocContent
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  computed: {
    compName() {
      return 'DocContent'
    },
    docContent() {
      if (this.compProps.mate) {
        return this.compProps.mate.privateProps || {}
      } else {
        return {}
      }
    }
  }
}
</script>
